import { MethodType } from '../constants/MethodType'
const api = require('./api')

export const fetchGroupList = ({ noIdFilter, ...params }) => api.request(1, `/groups/${noIdFilter ? '' : '?id!=0'}`, MethodType.GET, params)

export const fetchGroup = (id, params) => api.request(1, `/groups/${id}`, MethodType.GET, params)

export const addGroup = params => api.request(1, '/groups', MethodType.POST, params)

export const modifyGroup = (id, params) => api.request(1, `/groups/${id}`, MethodType.PUT, params)

export const deleteGroup = (id, params) => api.request(1, `/groups/${id}`, MethodType.DELETE, params)

export const fetchGroupUser = (id, params) => {
  return api.request(1, `/groupUsers?userId=${id} `, MethodType.GET, params)
}

export const fetchSources = params => api.request(1, '/dataSourceTypes', MethodType.GET, params)

export const fetchGroupUserList = params => api.request(1, '/getGroupUsers', MethodType.GET, params)

export const addGroupUser = params => api.request(1, '/groupUsers', MethodType.POST, params)

export const modifyGroupUser = (groupId, userId, params) => api.request(1, `/groupUsers/${groupId}/${userId}`, MethodType.PATCH, params)

export const fetchGroupSingleUsers = (id, params) => api.request(1, `/getGroupUsers?userId=${id}`, MethodType.GET, params)

export const deleteGroupUser = (groupId, userId, params) => api.request(1, `/groupUsers/${groupId}/${userId}`, MethodType.DELETE, params)

// ---------- SITE ----------

export const addSite = params => api.request(1, '/groupSites', MethodType.POST, params)

export const fetchSiteListFromSite = params => api.request(1, '/getSites', MethodType.GET, params)

export const deleteSite = (id, params) => api.request(1, `/groupSites/${id}`, MethodType.DELETE, params)

export const modSite = (id, params) => api.request(1, `/groupSites/${id}`, MethodType.PUT, params)

export const fetchSiteList = (params) => {
  params.includes = 'creator'
  return api.request(1, '/groupSites', MethodType.GET, params)
}

// ---------- TRACK ----------

export const fetchTrackList = (params = {}) => {
  params.includes = 'creator'
  return api.request(1, '/groupTrackBrands', MethodType.GET, params)
}

export const fetchTrackListFromTrack = params => api.request(1, '/track/networks', MethodType.GET, params)

export const fetchTrackNetworksOptions = params => api.request(1, '/track/networks', MethodType.GET, params)

export const fetchTrackAdvertisersOptions = params => api.request(1, '/track/advertisers', MethodType.GET, params)

export const fetchTrackBrands = (networkId, advertiserId, params) => api.request(1, `/track/groups/${networkId}/${advertiserId}`, MethodType.GET, params)

export const fetchCampByNetwork = (network, params) => api.request(1, `/track/campaigns/${network}`, MethodType.GET, params)

export const fetchCampByTrackBrand = (trackBrand, params) => api.request(1, `/track/campaigns/${trackBrand}`, MethodType.GET, params)

export const addTrack = params => api.request(1, '/groupTrackBrands', MethodType.POST, params)

export const modTrack = (id, params) => api.request(1, `/groupTrackBrands/${id}`, MethodType.PUT, params)

export const deleteTrack = (id, params) => api.request(1, `/groupTrackBrands/${id}`, MethodType.DELETE, params)
